export const formatBytes = (bytes = 0, decimals = 2) => {
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const mimeTypes = {
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
};

export const addExpiryTimeRange = (expiryTime) => {
    return Date.now() + expiryTime * 1000;
};

/**
 * Returns the current date as an object with year, month, and day.
 * @returns {{ year: number, month: number, day: string }}
 */
export const download = (filename, data) => {
    const blob = new Blob([JSON.stringify(data, null, 4)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
/**
 * Returns the current date as an object with year, month, day, hours, minutes, seconds and date time stamp.
 * @returns {{ year: number, month: number, day: string, hours: number, minutes: number, seconds: number, dateTimeStamp: string }}
 */
export const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const dateTimeStamp = `${year}${month}${day}_${hours}${minutes}${seconds}`;
    return {
        year,
        month,
        day,
        hours,
        minutes,
        seconds,
        dateTimeStamp,
    };
};
